import { Box } from '@opendoor/bricks-next';
import { Flex } from '@opendoor/bricks/core';
import { ThemedLite } from '@opendoor/bricks/theme/ODThemeLite';

import articleEntryLookup from '../../cms/entries/articleV2';
import { EntryComponent } from '../../cms/entries/entries';
import RichTextRenderer from '../../cms/renderer';
import renderAsset from '../../cms/renderer/assets';
import { IComponentHighlightBox } from '../../declarations/contentful';

const renderHighlightBox = (entry: IComponentHighlightBox) => {
  const { fields } = entry;

  const style = {
    default: {
      background: 'neutrals40',
    },
    leftBorder: {
      background: 'neutrals40',
      borderLeft: '3px solid #ddd',
    },
    dropShadow: {
      background: 'neutrals0',
      boxShadow: 'z2',
    },
  };

  return (
    <Box className="embedded-entry-wrapper" $platform-web={{ gridColumn: '5 / -2' }}>
      <ThemedLite theme="legacy">
        <Flex
          {...style[fields.variant]}
          borderRadius="semiRounded"
          marginY={9}
          padding={[7, 10, null, null]}
          flexDirection={'row'}
          flexWrap={'wrap'}
          gap={6}
        >
          {fields.image && (
            <Flex
              width={fields.image.fields.file.details.image?.width ?? 200}
              height={'auto'}
              maxWidth={['100%', '50%', null, null]}
              flexDirection={'column'}
              alignSelf="center"
            >
              {renderAsset({
                src: fields.image.fields.file?.url,
                contentType: fields.image.fields.file?.contentType || 'image/png',
                width: fields.image.fields.file.details.image?.width ?? 200,
                height: fields.image.fields.file.details.image?.height ?? 200,
              })}
            </Flex>
          )}
          {fields.content && (
            <Flex alignItems={'flex-start'} flexDirection={'column'} flex={1}>
              <RichTextRenderer.Component
                body={fields.content}
                idToLoaderData={{}}
                entryLookup={articleEntryLookup}
              />
            </Flex>
          )}
        </Flex>
      </ThemedLite>
    </Box>
  );
};

const HighlightBox: EntryComponent<IComponentHighlightBox> = {
  render: renderHighlightBox,
};

export default HighlightBox;
